import { Box, Button, Text, theme } from "@pallet-hq/hegel"
import { FC } from "react"

type EmptyStateProps = {
    icon: FC
    heading: string
    subheading?: string
    action?: string
    handleClick?: () => any
    margin?: string
}

const EmptyState = ({
    icon: Icon,
    heading,
    subheading,
    action,
    handleClick,
    margin,
}: EmptyStateProps) => (
    <Box
        m={margin ?? `${theme.space.large} auto`}
        maxWidth="420px"
        style={{ textAlign: "center" }}
    >
        <Icon />
        <Text variant="headlineSmall" my="xsmall">
            {heading}
        </Text>
        {subheading && (
            <Text variant="paragraphMedium" color="gray600" mb="medium">
                {subheading}
            </Text>
        )}
        {action && (
            <Button variant="secondary" onClick={handleClick}>
                {action}
            </Button>
        )}
    </Box>
)

export default EmptyState
